enum EExceptionLevel {
  CRITICAL = 'critical',
  WARNING = 'warning',
}

export default EExceptionLevel;
